import { SvgIcon } from '@mui/material';

const Icon = (props: any) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <circle
      cx="11"
      cy="11"
      r="8"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="21"
      y1="21"
      x2="16.65"
      y2="16.65"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default Icon;
